import { json as jsonLanguage, jsonParseLinter } from "@codemirror/lang-json";
import { linter, lintGutter } from "@codemirror/lint";
import { EditorView, type Extension } from "@uiw/react-codemirror";
import { EDITOR_SURFACE } from "../../common/editor-theme";
import { CONTAINER_COUNTS } from "./counts";
import { isJsonLines } from "./lines";

// Held rather than rebuilt, as in /csv: a new array reconfigures the running editor, and a box ticked and unticked
// again would otherwise be two reconfigurations of an editor that ended up exactly as it started.
const HELD = new Map<boolean, Extension[]>();

export function editorExtensions(counts: boolean): Extension[] {
  const held = HELD.get(counts);
  if (held) return held;

  const built = [
    jsonLanguage(),
    counts ? CONTAINER_COUNTS : [],
    // `jsonParseLinter` reports an empty range, so the gutter carries the marker that is actually noticeable.
    linter(documentLinter),
    lintGutter(),
    EditorView.lineWrapping,
    ...EDITOR_SURFACE,
  ];

  HELD.set(counts, built);
  return built;
}

const parseLinter = jsonParseLinter();

// JSON Lines is a document this page writes itself, so a fault is only marked where the text is not that either.
function documentLinter(view: EditorView) {
  const found = parseLinter(view);
  return found.length && isJsonLines(view.state.doc.toString()) ? [] : found;
}

const RESULTS = new Map<boolean, Extension[]>();

// Nobody types into the matches, which are rewritten on every keystroke above them, so the pane is /mock's read-only one.
export function resultExtensions(counts: boolean): Extension[] {
  const held = RESULTS.get(counts);
  if (held) return held;

  const built = [
    jsonLanguage(),
    counts ? CONTAINER_COUNTS : [],
    EditorView.editable.of(false),
    EditorView.contentAttributes.of({ "aria-label": "Query result" }),
    EditorView.lineWrapping,
    ...EDITOR_SURFACE,
  ];

  RESULTS.set(counts, built);
  return built;
}
